import { Switch, Route, Redirect, useHistory } from 'react-router-dom';

import { PlanEnum } from 'api-bible-shared-lib/utils/types';
import Card from '../components/Card';
import Container from '../components/Container';
import Step from '../components/Step';
import ApplicationForm from '../components/ApplicationForm';
import PlanSelection from '../components/PlanSelection';
import { IconDownChevron } from '../components/Icons';

import { useApplications } from '../contexts/Applications';

const step0Url = '/application/create';
const step1Url = '/application/create/plan';
const step2Url = '/application/create/details';

export default function ApplicationCreation() {
  const history = useHistory();

  const { createApplication } = useApplications();

  return (
    <Container>
      <Switch>
        {/* Redirect to first step */}
        <Route exact path={step0Url}>
          <Redirect to={step1Url} />
        </Route>

        {/* step 1 */}
        <Route exact path={step1Url}>
          <Step stepNumber={1} title="Choose your plan." subtitle="Plan Type" className="max-w-5xl">
            <Card className="px-12 py-12">
              <PlanSelection
                handlePlanSelect={(plan) => history.push(`${step2Url}?plan=${plan}`)}
              />
            </Card>
          </Step>
        </Route>

        {/* step 2 */}
        <Route
          exact
          path={step2Url}
          render={({ location }) => {
            const plan = new URLSearchParams(location.search).get('plan') || '';
            if (!Object.values(PlanEnum).includes(plan as PlanEnum))
              return <Redirect to={step1Url} />;

            return (
              <Step stepNumber={2} title="Create a new application." subtitle="New Application">
                <Card className="px-12 py-12">
                  <ApplicationForm
                    backUrl={step1Url}
                    initialAppValues={{ plan: plan as PlanEnum }}
                    handleSubmit={(app) =>
                      createApplication(app).then((createdApp) => {
                        history.push(`/application/${createdApp.id}`);
                      })
                    }
                    submitText={
                      <>
                        Create Application{' '}
                        <IconDownChevron className="w-6 h-6 transform -rotate-90" />
                      </>
                    }
                  />
                </Card>
              </Step>
            );
          }}
        />
      </Switch>
    </Container>
  );
}
